import React from "react";
import { fetchOrgSettings } from "../../actions/settings";
import Info from "../../components/info/Info";
import { wrapper } from "../../store";

export const getServerSideProps = wrapper.getServerSideProps((store) => async () => {
  await store.dispatch(fetchOrgSettings());
});

function Sveden() {
  const childNumSveden = 0;

  return <Info childNum={childNumSveden} pathnamePage="sveden"/>;
}

export default Sveden;
